<template>
  <div
    class="modalMask"
    v-if="visible"
    @click.self="handleClickOutside"
    @touchmove.self.prevent
  >
    <div class="container">
      <div class="header" v-if="withHeader">
        <div class="title">奖励包含</div>
      </div>
      <div
        :class="['closeBtn', { withHeader: withHeader }]"
        @click="handleClickClose"
      ></div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    closeable: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClickOutside() {
      this.closeable && this.$emit('close');
    },
    handleClickClose() {
      this.$emit('close');
    }
  }
};
</script>

<style lang="less" scoped>
.modalMask {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.88);

  .container {
    position: relative;
    width: 582px;
    min-height: 200px;
    border-radius: 20px;

    .closeBtn {
      position: absolute;
      top: -80px;
      right: -10px;
      width: 60px;
      height: 60px;
      background: center / cover no-repeat url('../assets/images/close-btn.png');

      &.withHeader {
        top: -240px;
      }
    }

    .header {
      position: absolute;
      top: 0;
      left: 0;
      transform: translateY(-212px);
      width: 582px;
      height: 213px;
      background: center / contain no-repeat
        url('../assets/images/modal-header-award.png');
      .fc;

      .title {
        font-weight: 600;
        margin-top: 110px;
        font-size: 44px;
        color: #b95001;
      }
    }
  }
}
</style>
